
import CompoundCategoryListComponent from "../../../components/compound_categories/Index.vue";

export default {
  components: {
    CompoundCategoryListComponent
  }
}
